import { reactive } from 'vue';

const state = reactive({
  open: false,
  mode: 'alert',
  variant: 'info',
  title: '',
  message: '',
  detail: '',
  confirmText: '',
  cancelText: '',
  impact: [],
});

const queue = [];
let resolveCurrent = null;

function normalise(input, mode) {
  const options = typeof input === 'string' ? { message: input } : (input || {});
  const variant = options.variant || (mode === 'confirm' ? 'warning' : 'info');
  return {
    mode,
    variant,
    title: options.title || ({ danger: '确认危险操作', warning: '请确认操作', success: '操作完成', info: '提示' })[variant],
    message: options.message || '',
    detail: options.detail || '',
    confirmText: options.confirmText || (mode === 'confirm' ? '确认继续' : '知道了'),
    cancelText: options.cancelText || '取消',
    impact: Array.isArray(options.impact) ? options.impact.filter((item) => item && item.value) : [],
  };
}

function showNext() {
  if (state.open || !queue.length) return;
  const request = queue.shift();
  Object.assign(state, request.options, { open: true });
  resolveCurrent = request.resolve;
}

function enqueue(input, mode) {
  return new Promise((resolve) => {
    queue.push({ options: normalise(input, mode), resolve });
    showNext();
  });
}

function settle(value) {
  if (!state.open) return;
  state.open = false;
  const resolve = resolveCurrent;
  resolveCurrent = null;
  if (resolve) resolve(value);
  window.setTimeout(showNext, 180);
}

export const dialogService = {
  state,
  confirm(input) { return enqueue(input, 'confirm'); },
  alert(input) { return enqueue(input, 'alert'); },
  accept() { settle(true); },
  cancel() { settle(false); },
};

export default {
  install(app) {
    app.config.globalProperties.$dialog = dialogService;
    app.provide('dialog', dialogService);
  },
};
